export default [
  {
    path: '/admin/buildings',
    name: 'admin-buildings',
    component: () => import('@/views/buildings/BuildingsView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/classrooms',
    name: 'admin-classrooms',
    component: () => import('@/views/classrooms/ClassroomsView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/faculties',
    name: 'admin-faculties',
    component: () => import('@/views/faculties/FacultiesView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/programs',
    name: 'admin-programs',
    component: () => import('@/views/programs/ProgramsView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/courses',
    name: 'admin-courses',
    component: () => import('@/views/courses/CoursesView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/sections',
    name: 'admin-sections',
    component: () => import('@/views/sections/SectionsView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/teachers',
    name: 'admin-teachers',
    component: () => import('@/views/teachers/TeachersView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/persons',
    name: 'admin-persons',
    component: () => import('@/views/persons/PersonsView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/params',
    name: 'admin-params',
    component: () => import('@/views/params/ParamsView.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
]
